import { createIcon } from '../icon'
import PhoneIcon from '@/components/atoms/svg/PhoneIcon'

export const PhoneIconDefault = createIcon(PhoneIcon)
